import { registerRemotes } from '@module-federation/runtime'

const registeredRemotes = new Set()

function preferHttpForLocal(url) {
  const s = String(url || '').trim()
  if (!s) return ''
  if (s.startsWith('https://') && s.includes('.local')) {
    return `http://${s.slice('https://'.length)}`
  }
  return s
}

function getRemoteConfig(name) {
  // Sportsbook commented out so dev does not try to load it (sportsbook-web often not running in dev).
  if (name === 'sportsbook') return null
  const entry =
    name === 'virtual'
      ? preferHttpForLocal(process.env.REACT_APP_REMOTE_VIRTUAL_ENTRY)
      : ''
  if (!entry) return null
  return { name, entry, alias: name, type: 'module' }
}

/**
 * Register a single remote by name ('virtual' | 'sportsbook') once. Idempotent.
 * Returns a Promise that resolves when registration is done (for async runtimes).
 */
export function registerRemoteOnce(remoteName) {
  if (registeredRemotes.has(remoteName)) {
    return Promise.resolve()
  }
  const config = getRemoteConfig(remoteName)
  if (!config) {
    return Promise.resolve()
  }
  try {
    const result = registerRemotes([config])
    registeredRemotes.add(remoteName)
    const p = result != null && typeof result.then === 'function' ? result : Promise.resolve()
    return p
  } catch {
    // Federation runtime may not be initialized yet in some dev edge-cases.
    return Promise.resolve()
  }
}

/**
 * Register all platform remotes (virtual + sportsbook). Kept for backwards compatibility.
 * Prefer on-demand registration via registerRemoteOnce in route-level components.
 */
export function registerPlatformRemotes() {
  registerRemoteOnce('virtual')
  registerRemoteOnce('sportsbook')
}

